var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bold-bar-rank"},[_c('div',{staticClass:"echarts-warpper",class:{ 'echarts-no-data': !_vm.data.xAxisData.length }},[(_vm.data.xAxisData.length)?_c('e-charts',{ref:"echarts",attrs:{"options":_vm.options}}):_c('not-data')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }